import { MessageCircle } from 'lucide-react';
import { STORE_PHONE } from '../lib/constants';

export default function WhatsAppFloat() {
  const msg = encodeURIComponent('Olá MotoVeloz, tenho uma dúvida.');
  return (
    <a
      href={`https://wa.me/${STORE_PHONE}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-20 sm:bottom-6 right-4 sm:right-6 z-50 bg-[#25D366] hover:bg-[#20BA5C] text-white rounded-full p-3.5 sm:p-4 shadow-lg shadow-black/30 hover:scale-110 transition-all duration-200"
      aria-label="Fale conosco no WhatsApp"
    >
      <MessageCircle className="h-6 w-6 sm:h-7 sm:w-7" />
    </a>
  );
}
